var angular = require("angular");

module.exports = angular.module("ssn.directives",[]);



// WEBPACK FOOTER //
// ./js/directives/directivesModule.js